import venue from "@/assets/cc_img5_hockey.png";

const validates = [
  "Pricing", "Session volume", "Repeat customer behavior",
  "Video upsell conversion", "Group event demand", "Franchise economics",
  "Sports scenario popularity", "Brand partnership opportunities",
];

export function Flagship() {
  return (
    <section id="flagship" className="relative py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="absolute -inset-4 led-grid opacity-30 pointer-events-none" />
          <img src={venue} alt="Flagship ClutchCube venue exterior at dusk" width={1600} height={1024} loading="lazy" className="relative rounded-sm shadow-elevated border border-border/60" />
          <div className="absolute -bottom-6 -right-6 bg-primary text-primary-foreground px-6 py-4 font-display text-2xl tracking-wider shadow-glow">
            $10M RAISE
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Flagship Location</p>
          <h2 className="font-display text-4xl sm:text-5xl leading-tight">
            The first location <br /><span className="text-gradient-ember">becomes the blueprint.</span>
          </h2>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
            We are raising $10M to build the first ClutchCube flagship location — a premium
            physical entertainment venue with a branded entrance experience, lobby, immersive
            game rooms, ticketing system, recording infrastructure, video production workflow,
            merchandise opportunities, and customer data systems.
          </p>
          <div className="mt-8">
            <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">The flagship will validate</div>
            <div className="flex flex-wrap gap-2">
              {validates.map((v) => (
                <span key={v} className="px-3 py-1.5 text-sm border border-border bg-card rounded-sm">{v}</span>
              ))}
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
            <a
              href="#invest"
              className="inline-flex items-center justify-center px-7 py-4 bg-primary text-primary-foreground font-semibold uppercase tracking-widest text-sm rounded-sm shadow-glow hover:translate-y-[-2px] transition"
            >
              Request Investor Deck
            </a>
            <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">
              Flagship plan and financial model included in the deck.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
